import { createFileRoute } from '@tanstack/react-router';
import DocumentList from '~/containers/DocumentList';

export const Route = createFileRoute('/documents/$folderId/')({
  component: DocumentList,
});
